import { graphql } from '@/gql';
import type { AbTestGroupUpdateInput } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import util from '@/Utils/util';
import _ from 'lodash';

const props = [
  'associatedObjectId',
  'associatedObjectType',
  'data',
  'description',
  'groupLabel',
  'groupTarget',
  'groupType',
  'id',
  'isActiveForAssignment',
  'winner',
] as const;

export const abTestGroupUpdate = async (abTestGroupUpdate: AbTestGroupUpdateInput) => {
  const response = await mutationExecute({
    variables: { abTestGroupUpdate: _.pick(abTestGroupUpdate, props) },
    mutation: graphql(`
      mutation abTestGroupUpdate($abTestGroupUpdate: AbTestGroupUpdateInput!) {
        abTestGroupUpdate(abTestGroupUpdate: $abTestGroupUpdate) {
          __typename
          associatedObjectId
          associatedObjectType
          createdAt
          data
          description
          groupLabel
          groupTarget
          groupType
          id
          isActiveForAssignment
          updatedAt
          winner
        }
      }
    `),
  });

  if (response.errors?.length) {
    throw new Error(util.getGraphqlError({ graphQLErrors: response.errors }, false), { cause: response });
  }

  if (!response.data?.abTestGroupUpdate) {
    throw new Error('Unexpected empty response');
  }

  return response.data.abTestGroupUpdate;
};
